module.exports = __webpack_public_path__ + "img/logo_inabio4.3a3f5410.png";